import Vue from "vue";//引入vue
import VueRouter from "vue-router";//引入vue路由
import store from "@/store/store.js";//引入vuex

import Home from "@/components/nav/Home.vue";//首页
import Search from "@/components/nav/Search.vue";//探索
import Member from "@/components/nav/Member.vue";//vip
import Popular from "@/components/nav/Popular.vue";//热门
import Prevalent from "@/components/nav/Prevalent.vue";//流行
import Classics from "@/components/nav/Classics.vue";//经典
import Collect from "@/components/nav/Collect.vue";//收藏
import Denglu from "@/components/login/denglu.vue"//登录
import Register from "@/components/login/register.vue";//注册
import Vocalist from "@/components/details/vocalist.vue";//歌手详情页
import Geren from "@/components/login/geren.vue"// 个人页
import Sousuo from "@/components/details/sousuo.vue"//搜索页
import SetUp from "@/components/nav/SetUp.vue"//设置页
import Zhaohui from "@/components/login/zhaohui.vue";//密码找回页
import Xieyi from "@/components/details/xieyi.vue";//协议
import Yinsi from "@/components/details/yinsi.vue";//隐私
import Weicheng from "@/components/details/weicheng.vue";//未成年
import Vipfw from "@/components/details/vipFw.vue";//vip 服务协议
import SongXf from "@/components/details/songXf.vue";//vip 续费协议
import Songfuwu from "@/components/details/songFuwu.vue";//音乐服务协议
import Shequ from "@/components/nav/Shequ.vue";//社区
import SmRz from "@/components/login/smrz.vue";//实名认证
import Qingnian from "@/components/details/jubao.vue";//青年举报
import shouye from "@/components/nav/shouye.vue";//首页2
Vue.use(VueRouter);//挂在路由插件
const routes = [//路由表示的是url和组件的一一对应的关系，使用path属性表示url路径，使用component属性表示组件
    {
        name:'Nshouye',//Home
        path:'/',
        component:shouye,
    },
    {
        name:'Nhome',//Home
        path:'/home',
        component:Home,
    },
    {
        name:'Ngeren',//个人页
        path:'/geren',
        component:Geren,
         //独享前置守卫
		beforeEnter:(to,from,next)=>{
            if(store.state.LoginStatus!==''){
                next();
            }else{
                next('/');
            }
		},
    },
    
    {
        name:'Ndenglu',//登录
        path:'/login',
        component:Denglu
    },
    {
        name:'Nsetup',//设置页
        path:'/setup',
        component:SetUp
    },
    {
        name:'Nsousuo',//搜索
        path:'/sousuo',
        component:Sousuo
    },
    {
        name:'Nregister',//注册
        path:'/register',
        component:Register
    },
    {
        name:'Nzhaohui',//密码找回
        path:'/zhaohui',
        component:Zhaohui
    },
    {
        name:'Nsearch',//探索
        path:'/search',
        component:Search
    },
    {
        name:'Nmember',//vip
        path:'/member',
        component:Member
    },
    {
        name:'Npopular',//热门
        path:'/popular',
        component:Popular
    },
    {
        name:'Nprevalent',//流行
        path:'/prevalent',
        component:Prevalent
    },
    {
        name:'Nclassics',//经典
        path:'/classics',
        component:Classics
    },
    {
        name:'Ncollect',//收藏
        path:'/collect',
        component:Collect
    },
    {
        name:'Nvocalist',//歌手详情
        path:'/vocalist/:id',
        component:Vocalist,
    },
    {
        name:'Nxieyi',//协议
        path:'/xieyi',
        component:Xieyi
    },
    {
        name:'Nyinsi',//隐私
        path:'/yinsi',
        component:Yinsi
    },
    {
        name:'Nweicheng',//未成年
        path:'/weicheng',
        component:Weicheng
    },
    
// import Vipfw from "@/components/details/vipFw.vue";//vip 服务协议
// import SongXf from "@/components/details/songXf.vue";//vip 续费协议
// import Songfuwu from "@/components/details/songFuwu.vue";//音乐服务协议
    {
        name:'Nvipfuwu',//vip 服务协议
        path:'/vipfuwu',
        component:Vipfw
    },
    {
        name:'Nsongxf',//vip 续费协议
        path:'/songxf',
        component:SongXf
    },
    {
        name:'Nsongfuwu',//音乐服务协议
        path:'/songfuwu',
        component:Songfuwu
    },
    {
        name:'Nshiming',//实名认证
        path:'/smrz',
        component:SmRz
    },
    {
        name:'Nreport',//青年举报
        path:'/report',
        component:Qingnian
    },
    {
        name:'Nshequ',//社区
        path:'/shequ',
        components:{
            shequs:Shequ
        },
        //独享前置守卫
		beforeEnter:(to,from,next)=>{
            store.commit('changeSqHone',true);
			if(store.state.SqHone==true){
                next();
            }else{
                next('/home');
            }
		},
    },
    

]
const router = new VueRouter({// 生成一个路由实例
    // mode:'history',
    // base:process.env.BASE_URL,
    routes// 配置项-配置视图和路由之间的对应关系
});
//修改原型对联 的push 

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
//导航守卫
// router.beforeEach((to,from,next)=>{
//     console.log(to,from)
//     next();
// });
// router.afterEach((to, from)=>{
//     console.log(to,from)
//     if(from.path == '/shequ'){
//         store.commit('changeSqHone',false)
//     }
// });

export default router // 导出路由实例